import Modal from './Modal';

export default function ConfirmDialog({ message, onConfirm, onCancel }) {
  return (
    <Modal title="Confirm" onClose={onCancel}>
      <p className="text-[#94A3B8] text-sm mb-4">{message}</p>
      <div className="flex gap-3 justify-end">
        <button 
          onClick={onCancel} 
          className="button-ghost"
          data-testid="confirm-cancel-btn"
        >
          Cancel
        </button>
        <button 
          onClick={onConfirm} 
          className="bg-[#EF4444] text-white font-bold font-syne rounded-lg px-4 py-2 hover:bg-[#DC2626] transition-colors"
          data-testid="confirm-delete-btn"
        >
          Delete
        </button>
      </div>
    </Modal>
  );
}
